import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/identificatie/";

const IdentificatieApi = {
	get(transactieId, isNew) {
		const serviceUrl = prependRoot(`${routePrefix}/${transactieId}/${!!isNew}`, getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	save(model) {
		const serviceUrl = prependRoot(routePrefix + '/', getApiRoot());
		return axios.put(serviceUrl, model,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},
	activateSportclub(transactieId) {
		const serviceUrl = prependRoot(routePrefix + 'activateSportclub/' + transactieId, getApiRoot());
		return axios.put(serviceUrl,
			{
				headers: {
					accept: "application/json"
				}
			});
	},
	getSportclubIsActive(transactieId) {
		const serviceUrl = prependRoot(`${routePrefix}getsportclubisactive/${transactieId}`, getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default IdentificatieApi;
